import './App.css';
import React, { Component } from 'react';
// eslint-disable-next-line
import { useState, useEffect } from 'react';
import fire from './fire';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
// eslint-disable-next-line
import Link from '@material-ui/core/Link';
// eslint-disable-next-line
import ProTip from './ProTip';
import Slider from '@material-ui/core/Slider';
// eslint-disable-next-line
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from '@material-ui/core/styles';
import { moviesData } from "./movies";

import 'react-html5-camera-photo/build/css/index.css';

import ImagePreview from './ImagePreview'; // source code : ./src/demo/AppWithImagePreview/ImagePreview

import Camera from 'react-html5-camera-photo';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      messages: [], movie1: {title: "Green Mile", description: "some description of green mile"}, movie2: {title: "The Hangover"}, movie3: {title: "The Vanishing"},
      joy: 50, sadness: 50, anger: 50, fear: 50, surprise: 50
    }; // <- set up react state
    this.updateMovies();
  }

  componentWillMount(){
    /* Create reference to messages in Firebase Database */
    let messagesRef = fire.firestore().collection("messages")
    //messagesRef.get().then(querySnapshot => {
    //  const data = querySnapshot.docs.map(d => ({"id": d.id, "data": d.data()}));
    //  console.log(data);
    //  this.setState({messages: data})
    //});
    messagesRef.onSnapshot(snapshot => {
      snapshot.docChanges().forEach( change => {
        if (change.type === "added") {
          console.log("New tutorial: ", change.doc.data());
          this.setState({ messages: [{"id": change.doc.id, "data": change.doc.data()}].concat(this.state.messages),  });
        }
        if (change.type === "modified") {
          console.log("Modified tutorial: ", change.doc.data());
        }
        if (change.type === "removed") {
          console.log("Removed tutorial: ", change.doc.data());
        }
      });
    });
  }

  addMessage(e){
    e.preventDefault(); // <- prevent form submit from reloading the page
    /* Send the message to Firebase */
    fire.firestore().collection('messages')
      .add({"value": this.inputEl.value})
      .then(() => {
        console.log("Document successfully written!");
      }).catch(error => {
        console.error("Error writing document: ", error);
      });
    this.inputEl.value = ''; // <- clear the input
  }

  changeJoy(e, value) {
    console.log(value)
    this.setState({"joy": value})
    this.updateMovies()
  }

  changeSad(e, value) {
    console.log(value)
    this.setState({"sadness": value})
    this.updateMovies()
  }

  changeEm3(e, value) {
    console.log(value)
    this.setState({"anger": value})
    this.updateMovies()
  }

  changeEm4(e, value) {
    console.log(value)
    this.setState({"fear": value})
    this.updateMovies()
  }

  changeEm5(e, value) {
    console.log(value)
    this.setState({"surprise": value})
    this.updateMovies()
  }

  updateMovies() {
    const props = ['joy', 'sadness', 'anger', 'fear', 'surprise']
    const normalizedState = {}
    // normalizing state to use same scale as in dataset
    for(let prop of props) {
      const min = Math.min(...moviesData.map(m => m[prop]))
      const max = Math.max(...moviesData.map(m => m[prop]))
      normalizedState[prop] = this.state[prop] / 100 * (max - min) + min
    }
    console.log(normalizedState)

    for(let movie of moviesData) {
      movie.distance = Math.pow(
        props.reduce((acc, p) => {
          return acc + Math.pow(normalizedState[p] - movie[p], 2)
        }, 0),
        0.5)
    }
    [this.state.movie1, this.state.movie2, this.state.movie3] = moviesData

      .sort((m1, m2) => m1.distance - m2.distance).slice(0, 3)
      //.sort((m1, m2) => m1.distance - m2.distance)
      //.slice(0, 7).sort((m1, m2) => Math.random() - 0.5).slice(0, 3)
    this.setState({"movie1": this.state.movie1, "movie2": this.state.movie2, "movie3": this.state.movie3})
    this.render()
  }

  cameraOpen() {
    console.log("camera")
    this.setState({"showCam": true});
  }

  handleTakePhotoAnimationDone(dataUri) {
    console.log('takePhoto');
    console.log(dataUri);
    const fileName = uuidv4() + '.png';
    const path = '/image/' + fileName;
    fire.storage().ref(path).putString(dataUri, 'data_url').then(result => {
      console.log(path);
      this.setState({"showCam": false});
      console.log('calling function');
      var recognizeFace = fire.functions().httpsCallable('recognizeFace');
      recognizeFace({imgName: fileName}).then((result) => {
        console.log(result);
        console.log(result.data);
        const face = result.data[0].faceAnnotations[0]
        //UNKNOWN, VERY_UNLIKELY, UNLIKELY, POSSIBLE, LIKELY, or VERY_LIKELY.
        console.log(visionApiMap[face.joyLikelihood])
        console.log(visionApiMap[face.sorrowLikelihood])
        console.log(visionApiMap[face.angerLikelihood])
        console.log(visionApiMap[face.surpriseLikelihood])
        console.log(result.data);

        this.setState({"joy": visionApiMap[face.joyLikelihood]})
        this.setState({"sadness": visionApiMap[face.sorrowLikelihood]})
        this.setState({"anger": visionApiMap[face.angerLikelihood]})
        this.setState({"surprise": visionApiMap[face.surpriseLikelihood]})

        this.updateMovies()

        this.render()

      }).catch((error) => {
        console.log(`error: ${JSON.stringify(error)}`);
      });
    });
  }

  render() {
    const classes = this.props;
    const marks = [
      {
        value: 25,
      },
      {
        value: 50,
      },
      {
        value: 75,
      },
    ];
    const isFullscreen = false;

    return (
      <Container maxWidth="md">
      <Box my={5}>
        <Typography variant="h4" component="h1" gutterBottom>
          Емоційний аналіз фільмів
        </Typography>
        <Grid container spacing={4} justify="center">
          <Grid item xs={1}>
            {/*<VerticalSlider label="Радість" />*/}

            <div className={classes.root} style={{height: 300}}><Slider
	    				    marks={marks}
                                            onChange={this.changeJoy.bind(this)}
                                                                value={this.state.joy}
                                            orientation="vertical"
                                            getAriaValueText={valuetext}
                                            defaultValue={30}
                                            aria-labelledby="vertical-slider"/>
            </div>
        <Typography id="vertical-slider" gutterBottom> Радість </Typography>
        </Grid>
        <Grid item xs={1}>
          {/*<VerticalSlider label="Сум" />*/}

          <div className={classes.root} style={{height: 300}}><Slider
	    				    marks={marks}
                                            onChange={this.changeSad.bind(this)}
                                                                value={this.state.sadness}
                                            orientation="vertical"
                                            getAriaValueText={valuetext}
                                            defaultValue={30}
                                            aria-labelledby="vertical-slider"/>
            </div>
        <Typography id="vertical-slider" gutterBottom> Сум </Typography>
        </Grid>
          <Grid item xs={1}>
	    {/*<VerticalSlider label="Злість" /> */}
            <div className={classes.root} style={{height: 300}}><Slider
	    				    marks={marks}
                                            onChange={this.changeEm3.bind(this)}
                                                                value={this.state.anger}
                                            orientation="vertical"
                                            getAriaValueText={valuetext}
                                            defaultValue={30}
                                            aria-labelledby="vertical-slider"/>
      </div>
	      <Typography id="vertical-slider" gutterBottom> Злість </Typography>
        </Grid>
          <Grid item xs={1}>
	    {/*<VerticalSlider label="Страх" /> */}
            <div className={classes.root} style={{height: 300}}><Slider
	    				    marks={marks}
                                            onChange={this.changeEm4.bind(this)}
                                            orientation="vertical"
                                            getAriaValueText={valuetext}
                                            defaultValue={30}
                                            aria-labelledby="vertical-slider"/>

            </div>
	      <Typography id="vertical-slider" gutterBottom> Страх </Typography>
        </Grid>
          <Grid item xs={1}>
	    {/*<VerticalSlider label="Подив" /> */}
            <div className={classes.root} style={{height: 300}}><Slider
	    				    marks={marks}
                                            onChange={this.changeEm5.bind(this)}
                                                                value={this.state.surprise}
                                            orientation="vertical"
                                            getAriaValueText={valuetext}
                                            defaultValue={30}
                                            aria-labelledby="vertical-slider"/>

          </div>

        <Typography id="vertical-slider" gutterBottom> Подив </Typography>
	    </Grid>
      <Grid item xs={1}>
        <div>
      {
        (this.state.showCam) ? <Camera onTakePhotoAnimationDone = {this.handleTakePhotoAnimationDone.bind(this)} isFullscreen={isFullscreen} />
	: <button onClick={this.cameraOpen.bind(this)}>Face recognize</button>
      }
        </div>
      </Grid>
          {/*<Container className={classes.cardGrid} maxWidth="md">*/}
          {/* movies */}
          <Grid item md>
            <Grid container spacing={2} xs>
              <Grid item key="movie1" xs={15} sm={6} md={4}>
      		<Card className={classes.card} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
        	<CardMedia className={classes.cardMedia} style={{paddingTop: '116.25%'}} image={this.state.movie1.poster} title="Image title" />
        	<CardContent className={classes.cardContent} style={{flexGrow: 1}}>
                	<Typography gutterBottom variant="h5" component="h2"> {this.state.movie1.name} </Typography>
                	<Typography> {this.state.movie1.plot} </Typography>
              	</CardContent>
              	<CardActions>
                	<Button size="small" color="primary"> View </Button>
                	<Button size="small" color="primary"> Edit </Button>
              	</CardActions>
            	</Card>
              </Grid>
              <Grid item key="movie2" xs={15} sm={6} md={4}>
      		<Card className={classes.card} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
          <CardMedia className={classes.cardMedia} style={{paddingTop: '116.25%'}} image={this.state.movie2.poster} title="Image title" />
        	<CardContent className={classes.cardContent} style={{flexGrow: 1}}>
                	<Typography gutterBottom variant="h5" component="h2"> {this.state.movie2.name} </Typography>
                	<Typography> {this.state.movie2.plot} </Typography>
              	</CardContent>
              	<CardActions>
                	<Button size="small" color="primary"> View </Button>
                	<Button size="small" color="primary"> Edit </Button>
              	</CardActions>
            	</Card>
              </Grid>
              <Grid item key="movie3" xs={15} sm={6} md={4}>
      		<Card className={classes.card} style={{height: '100%', display: 'flex', flexDirection: 'column'}}>
          <CardMedia className={classes.cardMedia} style={{paddingTop: '116.25%'}} image={this.state.movie3.poster} title="Image title" />
        	<CardContent className={classes.cardContent} style={{flexGrow: 1}}>
                	<Typography gutterBottom variant="h5" component="h2"> {this.state.movie3.name} </Typography>
                	<Typography> {this.state.movie3.plot} </Typography>
              	</CardContent>
              	<CardActions>
                	<Button size="small" color="primary"> View </Button>
                	<Button size="small" color="primary"> Edit </Button>
              	</CardActions>
            	</Card>
              </Grid>
            </Grid>
          </Grid>
          {/*}</Container>*/}
        </Grid>
        {/*<ProTip />*/}
        <Typography gutterBottom variant="h5" component="h2"> . </Typography>
        <Copyright />
      </Box>
      </Container>
    );
  }
}

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = theme => ({
  root: {
    height: 300,
  },
  cardGrid: {
	  test: 20
  },
  card: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  cardMedia: {
    paddingTop: '56.25%', // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
});

function valuetext(value) {
  return `${value}°C`;
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const visionApiMap = {
  "UNKNOWN": 50,
  "VERY_UNLIKELY": 0,
  "UNLIKELY": 25,
  "POSSIBLE": 50,
  "LIKELY": 75,
  "VERY_LIKELY": 100
}


export default withStyles(useStyles)(App);
